import * as exports0 from './Arrow.dom.js';
import * as exports1 from './util/int.js';
import * as exports2 from './compute/predicate.js';
Object.assign(arguments[0], exports0);